export default "__VITE_ASSET__C6JT62Ya__"